<template>
  <div class="Drop-Menu Drop-Menu--small">
    <div class="Drop-Menu__item">
      <FavouritesItem :postId="ID" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowEditPost">
      <EditPost :postId="ID" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowAddChannel">
      <AddChannel :postId="ID" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowApprove">
      <ApprovePost :postId="ID" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowPin">
      <PinPost :postId="ID" />
    </div>
    <div class="Drop-Menu__item">
      <ReportPost :postId="ID" />
    </div>
    <div class="Drop-Menu__item Drop-Menu__item--separator" v-if="get_isShowDelete">
      <DeletePost :postId="ID" />
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { POST_TYPES } from '@shared/constants/posts/postTypes.js';
  //--------------------------------------
  import PinPost from './items/PinPost/PinPost.vue';
  import ReportPost from './items/ReportPost/ReportPost.vue';
  import FavouritesItem from './items/Favourites/FavouritesItem.vue';
  import ApprovePost from './items/ApprovePost/ApprovePost.vue';
  import DeletePost from './items/DeletePost/DeletePost.vue';
  import EditPost from './items/EditPost/EditPost.vue';
  import AddChannel from './items/AddChannel/AddChannel.vue';
  //--------------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //--------------------------------------
  const ID = props.postId;
  //--------------------------------------
  //Является ли пользователь модератором?
  const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //Пост является моим собственным? 
  const get_isMinePost = computed(() => get_post.value.is_mine);
  //Пост относится к новостям
  const get_isNews = computed(() => get_post.value.model_name.toLowerCase() === POST_TYPES.NEWS);
  //Пост относится к материалам
  const get_isMaterials = computed(() => get_post.value.section_name === POST_TYPES.ANALYTICS);
  //Это подкаст?
  const get_isPodcast = computed(() => get_post.value.section_name === POST_TYPES.PODCAST);
  //Является ли пост мнением?
  const get_isOpinion = computed(() => get_post.value.model_name.toLowerCase() === POST_TYPES.OPINION);
  //Отображать ли кнопку 'Удалить'
  const get_isShowDelete = computed(() => {
    return (get_isModerator.value || get_isMinePost.value) && get_isOpinion.value;
  });
  //Отображать ли кнопку 'Опубликовать'
  const get_isShowApprove = computed(() => !get_post.value.live && get_isModerator.value);
  //Отображать ли кнопку 'Редактировать'
  const get_isShowEditPost = computed(() => (get_isOpinion.value || get_isMaterials.value) && (get_isMinePost.value || get_isModerator.value));
  //Отображать ли кнопку 'Закрепить'
  const get_isShowPin = computed(() => get_isModerator.value);
  //Отображать ли кнопку 'Добавить канал'
  const get_isShowAddChannel = computed(() => get_isModerator.value && !get_isPodcast.value);
</script>

<style lang="scss">
  @import "../../styles/Drop-Menu";
</style>